import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/home';
import About from './pages/About';
import Contact from './pages/contact';
import KlassiTechLayout from './pages/klassitech/KlassiTechLayout';
import KlassiTechHome from './pages/klassitech/KlassiTechHome';
import KlassiTechAutomation from './pages/klassitech/Automation';
import KlassiTechAI from './pages/klassitech/AI';
import KlassiTechDevelopment from './pages/klassitech/Development';
import KlassiTechFramework from './pages/klassitech/Framework';
import KlassiCareLayout from './pages/klassicare/KlassiCareLayout';
import KlassiCareHome from './pages/klassicare/KlassiCareHome';
import Babysitting from './pages/klassicare/Babysitting';
import Nanny from './pages/klassicare/Nanny';
import AuPair from './pages/klassicare/AuPair';

function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* KlassiTech Routes */}
            <Route path="/klassitech" element={<KlassiTechLayout />}>
              <Route index element={<KlassiTechHome />} />
              <Route path="automation" element={<KlassiTechAutomation />} />
              <Route path="ai" element={<KlassiTechAI />} />
              <Route path="development" element={<KlassiTechDevelopment />} />
              <Route path="framework" element={<KlassiTechFramework />} />
            </Route>

            {/* KlassiCare Routes */}
            <Route path="/klassicare" element={<KlassiCareLayout />}>
              <Route index element={<KlassiCareHome />} />
              <Route path="babysitting" element={<Babysitting />} />
              <Route path="nanny" element={<Nanny />} />
              <Route path="aupair" element={<AuPair />} />
            </Route>
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
